import { Injectable } from "@angular/core";

@Injectable()
export class RepositoryUrlService {
  private BITBUCKET = "bitbucket";
  private GITHUB = "github";
  private GITLAB = "gitlab";

  public findForProject(project: any) {
    const integrations = project.integrations;
    if (!integrations) {
      return;
    }

    if (integrations.github) {
      return this.repoUrl(integrations.github, this.GITHUB);
    } else if (integrations.gitlab) {
      return this.repoUrl(integrations.gitlab, this.GITLAB);
    } else if (integrations.bitbucket) {
      return this.repoUrl(integrations.bitbucket, this.BITBUCKET);
    }
  }

  private repoUrl(integration: any, serviceName: string) {
    if (serviceName === this.BITBUCKET) {
      if (!integration.accountName || !integration.repoName) {
        return "";
      }

      return (
        `https://${serviceName}.org/${integration.accountName}/` +
        `${integration.repoName}`
      );
    } else {
      if (!integration.username || !integration.repository) {
        return "";
      }

      const host = integration.host || `${serviceName}.com`;
      return `https://${host}/${integration.username}/${integration.repository}`;
    }
  }
}
